"use client";
function isChromium() {
  const userAgent = window.navigator.userAgent.toLowerCase();
  const isChromium =
    userAgent.includes("chrome") || userAgent.includes("chromium");
  const isOpera = userAgent.includes("opera") || userAgent.includes("opr");
  const isEdge = userAgent.includes("edg");
  // Chromium-based browsers typically include 'Chrome', 'Chromium', 'Opera', or 'Edge'
  if (isChromium && !isOpera && !isEdge) {
    return true; // It's Google Chrome or Chromium
  } else if (isEdge) {
    return true; // It's Microsoft Edge (Chromium-based)
  } else if (isOpera) {
    return true; // It's Opera (Chromium-based)
  }
  return false; // Not a Chromium-based browser
}

export default isChromium;
